import { FC, Fragment, useState } from "react";
import { Stack } from "@mui/material";
import type { GridApi } from "ag-grid-community";
import { OffHoursGridEmptyState } from "@/components/pages/automations/off-hours/grid/OffHoursGridEmptyState";
import { useGetUsersMeOffHoursSchedulesQuery } from "@/services/cloudchipr.api";
import { OffHoursGrid } from "@/components/pages/automations/off-hours/grid/OffHoursGrid";
import { OffHoursGridToolbar } from "@/components/pages/automations/off-hours/grid/OffHoursGridToolbar";

export const OffHours: FC = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const { data, isUninitialized } = useGetUsersMeOffHoursSchedulesQuery(
    {},
    { refetchOnMountOrArgChange: true },
  );

  if (isUninitialized) {
    return;
  }

  return (
    <Stack bgcolor="white" height="100%">
      <OffHoursGridEmptyState />

      {!!data?.length && (
        <Fragment>
          <OffHoursGridToolbar gridApi={gridApi} offHoursCount={data?.length} />

          <OffHoursGrid data={data} setGridApi={setGridApi} />
        </Fragment>
      )}
    </Stack>
  );
};
